import { useEffect } from 'react';
import hasDom from 'has-dom';
import { useStore } from 'react-redux';
import { waitUntil } from '@atc/wait-until';
import dispatchAnalyticsEvent from './dispatchAnalyticsEvent';
let clientHeight = 0;
export default data => {
  const store = useStore() || data?.store || {};
  const dispatchEvent = () => {
    dispatchAnalyticsEvent('delayedPageReady', {
      ...data,
      state: typeof store.getState === 'function' ? store.getState() : {}
    });
  };
  const handleDelayedPageReady = () => {
    // remove the listener after the first page event
    window.removeEventListener('analytics:page', handleDelayedPageReady);
    clientHeight = 0;
    waitUntil(() => {
      if (hasDom()) {
        // checks if lazy loaded contents are still loading by spying on client height change
        // if the height doesn't change much, we'll assume the page is ready "enough" for the next set of calls (e.g. 3rd party tags)
        if (clientHeight === document?.body?.clientHeight) {
          return true;
        }
        clientHeight = document?.body?.clientHeight;
      }
      return false;
    }, () => {
      dispatchEvent();
    }, 300, 2000, () => {
      dispatchEvent();
    });
  };
  useEffect(() => {
    // analytics:page -> analytics:pageReady -> analytics:delayedPageReady
    window.addEventListener('analytics:page', handleDelayedPageReady);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return () => {
    window.removeEventListener('analytics:page', handleDelayedPageReady);
    clientHeight = 0;
  };
};